/**
 * The app's languages, with no side effect: `@/i18n` initialises i18next on
 * import, which a plain formatter (`lib/locale.ts`) must not do — tests that
 * mock react-i18next broke when a shared module pulled it in (uiv2 7e).
 */
export type AppLocale = 'en' | 'fr' | 'ar';
export const SUPPORTED_LOCALES: readonly AppLocale[] = ['en', 'fr', 'ar'] as const;
export const RTL_LOCALES: ReadonlySet<AppLocale> = new Set(['ar']);
export const DEFAULT_LOCALE: AppLocale = 'en';
